import React, { useState } from 'react';
import './ContactUs.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Handle form submission here
  };

  const offices = [
    {
      id: 1,
      country: 'UAE',
      city: 'Dubai',
      address:
        '101 – Al Tawhidi Building 2, Sharaf DG Metro Station (Exit 1) Next Building to West Zone Supermarket- Al Fahidi, Bur Dubai, UAE',
      mapUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3608.5!2d55.2962!3d25.2632!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f43348a67e24b%3A0xa5f1466f0153b4b0!2sAl%20Fahidi%2C%20Dubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2s!4v1234567890',
    },
    {
      id: 2,
      country: 'India',
      city: 'Kozhikode',
      address: 'No. 1719, 7th Floor, Hilite Business Park, Kozhikode, India- 673011',
      mapUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3913.1!2d75.7804!3d11.2588!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba659f4c7e6f4a5%3A0x8e7c8e7c8e7c8e7c!2sHilite%20Business%20Park%2C%20Kozhikode%2C%20Kerala%20673011%2C%20India!5e0!3m2!1sen!2s!4v1234567890',
    },
    {
      id: 3,
      country: 'Egypt',
      city: 'Cairo',
      address:
        'Building 57, Moosa Ibnu Nusair Road, First Batch Police Station, Nasr City, Hay El Sabea, Abdullah Arabi Main Road, Tairan Road, Near Abou Ramy Restaurant, Nasr City, Cairo, Egypt',
      mapUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3453.4!2d31.3157!3d30.0444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14583fa60b21beeb%3A0x79dfb296e8423bba!2sNasr%20City%2C%20Cairo%20Governorate%2C%20Egypt!5e0!3m2!1sen!2s!4v1234567890',
    },
    {
      id: 4,
      country: 'Georgia',
      city: 'Tbilisi',
      address:
        '4th Floor, Axis Palace Business Center, 2 Gamrekeli Street, Saburtalo, Tbilisi, Georgia',
      mapUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2978.2!2d44.7865!3d41.7151!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40440cd7e64f626b%3A0x4f9c8b9c8b9c8b9c!2sGamrekeli%20St%2C%20Tbilisi%2C%20Georgia!5e0!3m2!1sen!2s!4v1234567890',
    },
    {
      id: 5,
      country: 'Armenia',
      city: 'Yerevan',
      address: 'University of Traditional Medicine, Marshal Babajanyan 38a Avan, Yerevan, Armenia',
      mapUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3047.7!2d44.5152!3d40.1792!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abd1df4a33a77%3A0x2b2b2b2b2b2b2b2b!2sMarshal%20Babajanyan%20St%2C%20Yerevan%2C%20Armenia!5e0!3m2!1sen!2s!4v1234567890',
    },
  ];

  return (
    <div className='contact-us'>
      {/* Hero Section */}
      <section className='contact-hero'>
        <div className='contact-hero-overlay'></div>
        <div className='contact-hero-content'>
          <h1 style={{color:'white'}}>Contact Us</h1>
          <p style={{color:'white'}}>Get in touch with our expert team for personalized education counseling services</p>
        </div>
      </section>

      {/* Contact Form & Info Section */}
      <section className='contact-main'>
        <div className='contact-container'>
          <div className='contact-content'>
            <div className='contact-form-section'>
              <div className='section-header'>
                <h2>Send us a Message</h2>
              </div>

              <form className='contact-form' onSubmit={handleSubmit}>
                <div className='form-row'>
                  <div className='form-group'>
                    <label htmlFor='name'>Full Name *</label>
                    <input
                      type='text'
                      id='name'
                      name='name'
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className='form-group'>
                    <label htmlFor='email'>Email Address *</label>
                    <input
                      type='email'
                      id='email'
                      name='email'
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className='form-row'>
                  <div className='form-group'>
                    <label htmlFor='phone'>Phone Number</label>
                    <input
                      type='tel'
                      id='phone'
                      name='phone'
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                  <div className='form-group'>
                    <label htmlFor='subject'>Subject *</label>
                    <select
                      id='subject'
                      name='subject'
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    >
                      <option value=''>Select Subject</option>
                      <option value='admission'>Admission Inquiry</option>
                      <option value='consultation'>Free Consultation</option>
                      <option value='visa'>Visa Assistance</option>
                      <option value='scholarship'>Scholarship Information</option>
                      <option value='other'>Other</option>
                    </select>
                  </div>
                </div>

                <div className='form-group'>
                  <label htmlFor='message'>Message *</label>
                  <textarea
                    id='message'
                    name='message'
                    rows='6'
                    value={formData.message}
                    onChange={handleChange}
                    placeholder='Tell us about your educational goals and how we can help you...'
                    required
                  ></textarea>
                </div>

                <button type='submit' className='submit-btn'>
                  <i className='icon-send'></i>
                  Send Message
                </button>
              </form>
            </div>

            <div className='contact-info-section'>
              <div className='contact-info-card'>
                <h3>Get in Touch</h3>
                <div className='contact-info-item'>
                  <i className='icon-phone'></i>
                  <div>
                    <h4>Call Us</h4>
                    <p>+971 581236700</p>
                  </div>
                </div>
                <div className='contact-info-item'>
                  <i className='icon-email'></i>
                  <div>
                    <h4>Email Us</h4>
                    <p>admin@destnation.org</p>
                  </div>
                </div>
                <div className='contact-info-item'>
                  <i className='icon-clock'></i>
                  <div>
                    <h4>Working Hours</h4>
                    <p>Mon - Fri: 9:00 AM - 6:00 PM</p>
                    <p>Sat: 10:00 AM - 4:00 PM</p>
                  </div>
                </div>
              </div>

              <div className='quick-contact'>
                <h4 style={{color:'white'}}>Quick Contact</h4>
                <p style={{color:'white'}}>Need immediate assistance? Our team is ready to help!</p>
                <div className='quick-contact-buttons'>
                  <a href='tel:+971581236700' className='quick-btn call-btn'>
                    <i className='icon-phone'></i>
                    Call Now
                  </a>
                  <a
                    href='https://wa.me/971581236700'
                    className='quick-btn whatsapp-btn'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <i className='icon-whatsapp'></i>
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Office Locations Section */}
      <section className='office-locations'>
        <div className='contact-container'>
          <div className='section-header'>
            <h2>Our Global Offices</h2>
            <p>Find us in major cities around the world</p>
          </div>

          <div className='offices-grid'>
            {offices.map((office) => (
              <div key={office.id} className='office-card'>
                <div className='office-map'>
                  <iframe
                    src={office.mapUrl}
                    width='100%'
                    height='200'
                    style={{ border: 0 }}
                    allowFullScreen=''
                    loading='lazy'
                    referrerPolicy='no-referrer-when-downgrade'
                    title={`${office.city} Office Location`}
                  ></iframe>
                </div>
                <div className='office-info'>
                  <div className='office-header'>
                    <h3>{office.country}</h3>
                    <span className='office-city'>{office.city}</span>
                  </div>
                  <div className='office-details'>
                    <div className='office-detail'>
                      <i className='icon-location'></i>
                      <span>{office.address}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className='contact-cta'>
        <div className='contact-container'>
          <div className='cta-content'>
            <h2>Ready to Start Your Journey?</h2>
            <p>Book a free consultation with our education experts today</p>
            <a href='/admission' className='cta-btn'>
              <i className='icon-calendar'></i>
              Book Free Consultation
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
